import commonMixin from './../mixins/_common';
import flashMessageMixin from './../mixins/_flash_messages';

// １ページに表示するアイテム件数
const LIMIT_PER_PAGE = 21;

// プレースホルダ名
const PLACE_HOLDER = {
    keyword: 'キーワード',
    item_code: '管理番号',
};

// デフォルトのソート
const DEFAULT_SORT = '+sort_priority';

// 商品点数制限エラーメッセージ
const ITEM_LIMIT_ERROR_MESSAGE = '登録商品が1,000件以上あります。「絞り込む」から絞り込んでください';

/**
 *  商品検索条件設定コンポーネント
 */
export default {
    template: '#item_search_condition_template',
    data() {
        return {
            // 検索条件エリア開閉状態
            is_open_item_search_area: false,
            // 詳細検索条件入力部が閉じている時:false
            is_detail_search: false,
            // 商品検索条件
            keyword: '',
            stock_flag: 'all_items', // all_items|stock_only
            not_keyword: '',
            min_price: '',
            max_price: '',
            search_mode: 'keyword',
            sort: DEFAULT_SORT,
            // エンター検索用フラグ
            can_enter_search: false,
            // 初回検索か（ページングでないか）
            is_first_search: false,
            // 税込価格への再計算を行った場合
            // 税抜か
            is_excluded_tax: false,
            // 消費税率
            tax_rate: '10',
        };
    },
    props: {
        // 検索ヒット最大数
        limit_per_page: {
            type: Number,
            required: false,
            default: LIMIT_PER_PAGE
        },
        // ページキー（カテゴリーキー）
        page_key: {
            type: String,
            required: false,
            default: null,
        },
        // 商品件数制限エラーを通知するか
        should_emit_item_limit_error: {
            type: Boolean,
            default: false,
        },
        // 消費税加算フラグ
        add_tax: {
            type: Boolean,
            default: false,
        }
    },
    mixins: [
        commonMixin,
        flashMessageMixin,
    ],
    computed: {
        // プレースホルダ
        placeHolder() {
            return PLACE_HOLDER[this.search_mode];
        },
        // キーワードサーチモードか否か
        isKeywordSearch() {
            return this.search_mode === 'keyword';
        },
    },
    emits: [
        'init-sort-arrow',
        'current-page',
        'item-list',
        'pages',
        'change-is-my-item-list',
        'item-limit-error',
    ],
    methods: {
        // エンターキーによる検索実行
        enterSearch: async function () {
            if (!this.can_enter_search) {
                return;
            }
            this.changeSort();
            await this.searchItems(1);
            this.can_enter_search = false;
        },
        // 商品検索ボタン押下による検索
        clickSearch: async function () {
            this.changeSort();
            await this.searchItems(1, true);
        },
        // 初回検索用(1ページ目、条件無しで検索、商品有無フラグ更新)
        firstSearch: async function () {
            this.clearSearchCondition();
            await this.searchItems(1);
        },
        // 検索条件エリアの表示非表示を切り替える
        toggleItemSearchArea: function () {
            this.is_open_item_search_area = !this.is_open_item_search_area;
        },
        // 詳細検索ボタン押下
        detailSearch: function () {
            // フラグ反転して詳細検索条件入力部の表示非表示を切り替える
            this.is_detail_search = !this.is_detail_search;
        },
        // ソートを変更
        changeSort: function (sort = DEFAULT_SORT) {
            this.$emit('init-sort-arrow');
            this.sort = sort;
        },
        // 詳細条件を初期化
        clearSearchCondition: function () {
            this.keyword = '';
            this.stock_flag = 'all_items';
            this.not_keyword = '';
            this.min_price = '';
            this.max_price = '';
            this.search_mode = 'keyword';
            this.sort = DEFAULT_SORT;
        },
        // 詳細条件を設定
        setSearchCondition: function (searchCondition) {
            this.keyword = searchCondition.keyword;
            this.stock_flag = searchCondition.stock_flag;
            this.not_keyword = searchCondition.not_keyword;
            this.min_price = searchCondition.min_price;
            this.max_price = searchCondition.max_price;
            this.search_mode = searchCondition.search_mode;
        },
        // 商品検索処理
        searchItems: async function (currentPage, firstSearchFlg = false) {
            this.$_loading();
            let message = this.exception_error_message;
            this.is_first_search = firstSearchFlg;
            // 商品管理番号検索でキーワードなしなら結果が0になってしまうのでリセット
            if (!this.keyword && this.search_mode === 'item_code') {
                this.search_mode = 'keyword';
            }
            await axios.get('/search_items', {
                params: {
                    hits: this.limit_per_page,
                    page: currentPage,
                    keyword: this.keyword,
                    stock_flag: this.stock_flag,
                    not_keyword: this.not_keyword,
                    min_price: this.min_price,
                    max_price: this.max_price,
                    search_mode: this.search_mode,
                    page_key: this.page_key,
                    sort: this.sort,
                    add_tax: (this.add_tax ? '1' : '0'),
                }
            }).then((response) => {
                if (response.data.status === 'OK') {
                    // 消費税率を取得
                    if (this.add_tax) {
                        this.is_excluded_tax = response.data.tax;
                        this.tax_rate = response.data.taxRate;
                    }
                    // 取得後更新
                    this.emitCurrentPage(currentPage);
                    // 検索結果を画面に反映する
                    this.emitItemList(response.data.data.items, currentPage);
                    // ページ数
                    this.emitPages(response.data.data.page_count);
                    // YahooMyItemListApiのデータを取得しているか
                    this.emitChangeIsMyItemList(response.data.isMyItemList);
                    message = '';
                } else {
                    message = response.data.message;
                }
            }).catch((error) => {
                message = this.getCatchMessage(error);
            });
            this.$_unloading();
            if (message) {
                if(this.should_emit_item_limit_error && message === ITEM_LIMIT_ERROR_MESSAGE) {
                    // エラーメッセージを表示せず、親へ通知する
                    this.emitItemLimitError(message);
                } else {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: message,
                    }, this.$parent);
                }
            } else {
                this.clearFlashMessage(null, this.$parent);
                this.emitItemLimitError('');
            }
        },

        // -------------------------
        // emit
        // -------------------------

        // 現在のページを通知
        emitCurrentPage: function (currentPage) {
            this.$emit('current-page', currentPage);
        },
        // 取得した商品データを通知
        emitItemList: function (itemList, currentPage) {
            const conditions = {
                'keyword': this.keyword,
                'stock_flag': this.stock_flag,
                'not_keyword': this.not_keyword,
                'min_price': this.min_price,
                'max_price': this.max_price,
                'search_mode': this.search_mode,
            };

            this.$emit('item-list', itemList, conditions, currentPage);
        },
        // ページ数を通知
        emitPages: function (pages) {
            this.$emit('pages', pages);
        },
        // YahooMyItemListApiのデータを取得しているか
        emitChangeIsMyItemList: function (isMyItemList) {
            this.$emit('change-is-my-item-list', isMyItemList);
        },
        // 商品件数制限エラー発生を通知
        emitItemLimitError: function (message) {
            this.$emit('item-limit-error', message);
        }
    }
};
